import React, { useState, useEffect } from "react";
import IntlMessages from "@iso/components/utility/intlMessages";
import HarvestModalWrapper from "./HarvestModal.styles";
import {
  Form,
  Input,
  Button,
  Select,
  Row,
  Col,
  DatePicker,
  Tabs,
  InputNumber,
  message,
  Timeline,
  Card
} from "antd";
import moment, { localeData } from 'moment';
import { useSelector, useDispatch } from "react-redux";
import modalActions from "@iso/redux/modal/actions";
import Loader from "@iso/components/utility/loader";
import { cropService } from "@iso/services";
import _, { values } from "lodash";
import styled from "styled-components";
import { harvestType } from "@iso/constants/harvestType";
import CropModalWrapper from "../PrimaryObject/CropModal.styles";
import { windDirection } from "@iso/constants/windDirection";
import { moonCycle } from "@iso/constants/moonCycle";
import { dateHelper } from "@iso/lib/helpers/dateHelper";
import { objectColors } from "@iso/constants/objectColors";
import PropertyMap from "../../PropertyMap";
import ViewHistory from './ViewHistory';
import BlockActivityList from "./BlockActivityList";
import AddActivityModal from "../Asset/AddActivityModal";
const { RangePicker } = DatePicker;
const { Option } = Select;
const { closeModal } = modalActions;
const { TabPane } = Tabs;

const HarvestModal = (props) => {
  const [form] = Form.useForm();
  const [cropForm] = Form.useForm();
  const [varietyForm] = Form.useForm();
  const [fields, setFields] = useState([]);
  const dispatch = useDispatch();
  const modalVisibility = useSelector((state) => state.modal.modalVisibility);
  const modalData = useSelector((state) => state.modal.modalData);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState("1");
  const [loadingCrop, setLoadingCrop] = useState(false);
  const [dataMob, setDataMob] = useState({});
  const [blockAcreage, setBlockAcreage] = React.useState("");
  const [blockCoordinates, setBlockCoordinates] = useState();
  const [dataObject,setDataObject] = useState({});
  const [visibleVarietyModal,setVisibleVarietyModal] = useState(false);

  const activePermission = useSelector(
    (state) => state.permission.activePermission
  );
  const [messageApi, contextHolder] = message.useMessage();
  const [crops, setCrops] = useState({});
  const [variety,setVariety] = useState({});
  const [visibleCrop, setVisibleCrop] = useState(false);
  useEffect(() => {
    if (props.propertyId) {
      cropService.getList(props.propertyId).then((res) => {
        if (res.code === "0000") {
          setCrops(res.crops);
          setModalLoading(false);
        }
      });
    }
  }, [props.propertyId]);

  useEffect(() => {
    if (modalData.type === "block") {
      if (modalData.object) {
        setDataObject(modalData.object);
      }
    
    setFields([
      {
        name: ["block", "name"],
        value: modalData.object.name || "",
      },
      {
        name: ["block", "crop"],
        value: modalData.object.crop || "",
      },
      {
        name: ["block", "variety"],
        value: modalData.object.variety || "",
      },
      {
        name: ["block", "batchCode"],
        value: modalData.object.batchCode || "",
      }, 
      {
        name: ["block", "type"],
        value: modalData.object.type || "",
      }, 
      {
        name: ["block", "acreage"],
        value: modalData.object.acreage ? parseFloat(modalData.object.acreage) : parseFloat(blockAcreage),
      },
      {
        name: ["block", "paddock"],
        value: modalData?.object.area || '',
      },
      {
        name: ['block', 'start_time'],
        value: modalData.object.start_time ? moment(modalData.object.start_time) : '',
      },
      {
        name: ['block', 'finish_time'],
        value: modalData.object.finish_time ? moment(modalData.object.finish_time) : '',
      },
      {
        name: ['block', 'machinery_time'],
        value: modalData.object.machinery_time ? moment(modalData.object.machinery_time) : '',
      },
      {
        name: ['block', 'layer_plastic'],
        value: modalData?.object?.layer_plastic || '' ,
      },
      {
        name: ['block', 'plastic_cost'],
        value: modalData?.object?.plastic_cost || '' ,
      },
      {
        name: ['block', 'resources'],
        value: modalData?.object?.resources || '' ,
      },
      {
        name: ['block', 'resources_cost'],
        value: modalData?.object?.resources_cost || '' ,
      },
      {
        name: ['block', 'machinery_cost'],
        value: modalData?.object?.machinery_cost || '' ,
      },
      {
        name: ["block", "color"],
        value: modalData?.object.color || "blue",
      },
      {
        name: ["block", "primary_object_id"],
        value: modalData?.object.primary_object_id || '',
      },
      
    ]);
  }}, [blockAcreage,modalData,dataObject]);

  const addCrop = (object, e) => {
    setVisibleCrop(true);
  };
  const cancelModalCrop = () => {
    if(visibleCrop){
    setVisibleCrop(false);
    cropForm.resetFields();
    }else{
      setVisibleVarietyModal(false);
      varietyForm.resetFields();
    }

    
  };

  const cancelModal = () => {
    setDataObject({});
    dispatch(closeModal());
    setActiveTab("1");
    setLoading(false);
    setBlockAcreage();
    setBlockCoordinates();
    form.resetFields();
  };

  const renderOptionsCrop = (object_crops) => {
    let crop_options = [];
    _.forEach(object_crops, (crop_opt, index) => {
      crop_options.push(
        <Option key={index} value={crop_opt.id}>
          <div>{crop_opt.name}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a crop" allowClear size="large">
        {crop_options}
      </Select>
    );
  };
  const renderOptionsColor = () => {
    let options = [];
    _.forEach(objectColors, (color, index) => {
      options.push(
        <Option key={index} value={color.value}>
          <ColorItemRow>
            <ColorItemPreview
              style={{ backgroundColor: color.color }}
            ></ColorItemPreview>
            <div>{color.label}</div>
          </ColorItemRow>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a color" allowClear size="large">
        {options}
      </Select>
    );
  };
  const renderOptionObject = (objects) => {
    let options = [];
    _.forEach(objects, (object, index) => {
      options.push(
        <Option key={object.id} value={object.id}>
          {object.name}
        </Option>
      );
    });
    return (
      <Select placeholder="Select an object" disabled = {dataObject?.primary_object_id ? true : false} allowClear size="large">
        {options}
      </Select>
    );
  };

  const addActivity = () => { 
    props.setVisibleActivity(true);
  }

  const renderOptionsHarvestType = () => {
    let options = [];
    // _.forEach(harvestType, (type, index) => {
    //   options.push(
    //     <Option key={index} value={type.value}>
    //       <div>{type.label}</div>
    //     </Option>
    //   );
    // });
    return (
      <Select placeholder="Select Activity" allowClear size="large">
        {options}
      </Select>
    );
  };

  const [activeTab, setActiveTab] = useState("1");

  const onChangeTab = (key) => {
    setActiveTab(key);
  };
  const onChange = (key) => {
    setCurrentTab(key);
  };

  const addVariety = () =>{
    setVisibleVarietyModal(true);
  }

  const renderOptionsVariety = () =>{
let variety_options = [];
    _.forEach('', (variety_opt, index) => {
      variety_options.push(
        <Option key={index} value={variety_opt.id}>
          <div>{variety_opt.name}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select a crop" allowClear size="large">
        {variety_options}
      </Select>
    );
  }

  const handleVarietySubmit = () =>{
    varietyForm
    .validateFields()
    .then((variety_values) => {
      onStoreVariety(variety_values);
    })
    .catch((info) => {
      console.log("Validate Failed:", info);
      setLoadingCrop(false);
    });
  }

  const onStoreVariety = (variety_values) =>{
    const variety_data = {
      crop: {
        ...variety_values.variety,
        property_id: props.propertyId,
      },
    };
  }
  
  const handleCropSubmit = (e) => {
    cropForm
      .validateFields()
      .then((crop_values) => {
        onStoreCrop(crop_values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
        setLoadingCrop(false);
      });
  };
  const onStoreCrop = (crop_values) => {
    const crop_data = {
      crop: {
        ...crop_values.crop,
        property_id: props.propertyId,
      },
    };

    cropService.storeOrUpdate(crop_data).then((res) => {
      if (res.code === "0000") {
        var tmp_crops = _.clone(crops);
        tmp_crops.push(res.crop);
        setCrops(tmp_crops);
        cancelModalCrop();
        cropForm.resetFields();
        setFields([
          {
            name: ["block", "crop"],
            value: res.crop.id,
          },
        ]);
      } else {
        setLoadingCrop(false);
      }
    });
  };

  const handleSubmit = (e) => {
    setLoading(true);
    form
      .validateFields()
      .then((values) => {
        values.block.property_id = props.propertyId;
        let coordinates = blockCoordinates;
        values.block.data_block = _.map(coordinates, (point) => {
          return point.toString().replace(",", ", ");
        });

        onStore(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
        setLoading(false);
      });
  };

  const onStore = (values) => {
    switch (props.propertyAcreageUnit) {
      case "acres":
        var acreage_by_acres = values.block.acreage;
        var acreage_by_hectare = (acreage_by_acres / 2.471).toFixed(2);
        var acreage_by_yard = (acreage_by_hectare * 11959.9005).toFixed(2);
        break;
      case "hectare":
        var acreage_by_hectare = values.block.acreage;
        var acreage_by_acres = (acreage_by_hectare * 2.471).toFixed(2);
        var acreage_by_yard = (acreage_by_hectare * 11959.9005).toFixed(2);
        break;
      case "yard":
        var acreage_by_yard = values.block.acreage;
        var acreage_by_hectare = (acreage_by_yard / 11959.9005).toFixed(2);
        var acreage_by_acres = (acreage_by_hectare * 2.471).toFixed(2);
        break;
      default:
        var acreage_by_hectare = values.block.acreage;
    }
    const data = {
      block: {
        ...values.block,
        finish_time: values.block.finish_time
          ? dateHelper.dateTimeForAPI(values.block.finish_time)
          : "",
        machinery_time: values.block.machinery_time
          ? dateHelper.dateTimeForAPI(values.block.machinery_time)
          : "",
        start_time: values.block.start_time
          ? dateHelper.dateTimeForAPI(values.block.start_time)
          : "",
        acreage_by_acres: acreage_by_acres,
        acreage_by_hectare: acreage_by_hectare,
        acreage_by_yard: acreage_by_yard,
      },
    };
  };
  return (
    <>
      {contextHolder}
      <HarvestModalWrapper
        visible={modalVisibility && modalData.type === "block"}
        maskClosable={true}
        onCancel={cancelModal}
        title={
          dataObject.name ? (
            modalData.viewHistoryVisible ? (
              <IntlMessages id="View History" />
            ):
           ( <IntlMessages id="Edit Block" />)
          
          ) : (
            <IntlMessages id="Add Block" />
          )
        }
        footer={[
          <Button key="back" onClick={cancelModal} className="cancel-button">
            {<IntlMessages id="propertyPage.modal.cancel" />}
          </Button>,
           !modalData.viewHistoryVisible ? 
          (activePermission == "owner" ||
            activePermission == "admin" ||
            activePermission == "modify") && (
            <Button
              key="submit"
              className="btn-success"
              type="primary"
              onClick={handleSubmit}
              loading={loading}
            >
              {<IntlMessages id="propertyPage.modal.save" />}
            </Button>
          ) :' ',
        ]}
      >
        <Tabs
          defaultActiveKey="1"
          className="form-body"
          onChange={onChangeTab}
          activeKey={activeTab}
        >
          {!modalData.viewHistoryVisible === true ? (
          <TabPane
            tab={<IntlMessages id="propertyPage.mobModal.detailTab" />}
            key="1"
          >
            {modalLoading ? (
              <Loader />
            ) : (
              <Form
                form={form}
                layout="vertical"
                scrollToFirstError
                fields={fields}
                id="#1"
              >
                <div>
                  <Form.Item
                    name={["block", "name"]}
                    className="isoInputWrapper"
                    label="Name"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                      {
                        whitespace: true,
                        message: "Please input your name",
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Input name" />
                  </Form.Item>
                  <Row>
                    <Col xs={{ span: 15 }} md={{ span: 17 }}>
                      <Form.Item
                        name={["block", "crop"]}
                        className="isoInputWrapper"
                        label="Crop"
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                        ]}
                      >
                        {renderOptionsCrop(crops)}
                      </Form.Item>
                    </Col>
                    <Col
                      xs={{ span: 8, offset: 1 }}
                      md={{ span: 6, offset: 1 }}
                    >
                      <Button
                        key="submit"
                        className="btn-create-crop"
                        type="primary"
                        onClick={addCrop}
                      >
                        {<IntlMessages id="+ Add New Crop" />}
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={{ span: 15 }} md={{ span: 17 }}>
                      <Form.Item
                        name={["block", "variety"]}
                        className="isoInputWrapper"
                        label="Variety"
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                        ]}
                      >
                        {renderOptionsVariety()}
                      </Form.Item>
                    </Col>
                    <Col
                      xs={{ span: 8, offset: 1 }}
                      md={{ span: 6, offset: 1 }}
                    >
                      <Button
                        key="submit"
                        className="btn-create-crop"
                        type="primary"
                        onClick={addVariety}
                      >
                        {<IntlMessages id="+ Add New Variety" />}
                      </Button>
                    </Col>
                  </Row>
                  <Form.Item
                    name={["block", "batch_code"]}
                    className="isoInputWrapper"
                    label="Batch code / seeds"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                      {
                        whitespace: true,
                        message: "Please input your  Batch code or seeds",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Input Batch code or seeds"
                    />
                  </Form.Item>
                 
                  {dataObject.name ? '' :
                  <div>
                    <Tabs defaultActiveKey="1" onChange={onChange}>
                      <TabPane tab="Area" key="1">
                        {currentTab == 1 && (
                          <Col xs={{ span: 24 }} md={{ span: 11 }}>
                            <Form.Item
                              name={["block", "primary_object_id"]}
                              className="isoInputWrapper"
                              label={
                                <IntlMessages id="Location" />
                              }
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]}
                            >
                              {renderOptionObject(props.primaryObjects)}
                            </Form.Item>
                          </Col>
                        )}
                      </TabPane>
                         
                      <TabPane tab="Location" key="2">
                        <div
                          className="propertyMap "
                          style={{ height: "auto" }}
                        >
                          <PropertyMap
                            className="weather-map-style"
                            isShowBlock={true}
                            setBlockAcreage={setBlockAcreage}
                            setBlockCoordinates={setBlockCoordinates}
                          />
                        </div>
                      </TabPane>
                    </Tabs>
                          
                  </div>
                  }
                  {(currentTab == 2  || dataObject?.name) && (
                    <>
                    <AcreageInput>
                      <Form.Item
                        name={["block", "acreage"]}
                        className="isoInputWrapper"
                        label="Acreage"
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                          {
                            type: "number",
                          },
                        ]}
                        style={{ width: "100%" }}
                      >
                        <InputNumber
                          disabled={true}
                          size="large"
                          placeholder="Input your Block acreage"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                      <SuffixAddon>
                        {props.propertyAcreageUnit
                          ? props.propertyAcreageUnit
                          : "hectare"}
                      </SuffixAddon>
                    </AcreageInput>
                    <Form.Item
                    name={["block", "color"]}
                    label="Colour on map"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                  >
                    {renderOptionsColor()}
                  </Form.Item>     
                  </>
                  )}

                  {dataObject.primary_object_id &&
                    <Form.Item
                              name={["block", "primary_object_id"]}
                              className="isoInputWrapper"
                              label={
                                <IntlMessages id="Location" />
                              }
                              
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]}
                            >
                              {renderOptionObject(props.primaryObjects)}
                            </Form.Item>
                  }
                </div>
               
              </Form>
            )}
          </TabPane>
          ):''}
          { dataObject?.name  && !modalData.viewHistoryVisible === true ? (
          <TabPane
            tab={<IntlMessages id="Activity" />}
            key="2"
          >
           <Row>
                  <Col xs={{ span: 7 }} md={{ span: 7 }}>
                    <Button
                      key="submit"
                      className="btn-create-breed"
                      type="primary"
                      onClick={addActivity}
                    >
                      Add Activity
                    </Button>
                  </Col>
                  <Col xs={{ span: 15 }} md={{ span: 17 }}></Col>
                </Row>
                <br/>
            <BlockActivityList
              dataId = {dataObject?.id}
              propertyId={props.propertyId}
            />
          </TabPane>
          ):''}
          {dataObject?.name ?
            <TabPane
            tab={<IntlMessages id="propertyPage.mobModal.historyTab" />}
            key={modalData.viewHistoryVisible ? "1":"3"} 
          >
          {modalData?.viewHistoryVisible ?
          '' :
          <Row>
              <Col xs={{ span: 7 }} md={{ span: 7 }}>
              </Col>
              <Col xs={{ span: 15 }} md={{ span: 17 }}></Col>
            </Row>
          }
           
            <br />
            {activeTab == (modalData.viewHistoryVisible ? "1":"3")  && (
              <ViewHistory
                dataId={dataObject.id}
             
              />
            )}
          </TabPane>
          :''}
         
          
        </Tabs>

        <CropModalWrapper
          visible={visibleCrop ? visibleCrop : visibleVarietyModal}
          onCancel={cancelModalCrop}
          maskClosable={false}
          centered
          title={visibleCrop ? <IntlMessages id="propertyPage.modal.crop.addCrop.title" /> : 'Add New Variety'}
          footer={[
            <Button
              key="back"
              onClick={cancelModalCrop}
              className="cancel-button"
            >
              {<IntlMessages id="propertyPage.modal.cancel" />}
            </Button>,
            <Button
              key="submit"
              className="btn-success"
              type="primary"
              onClick={visibleCrop ? handleCropSubmit  : handleVarietySubmit}
              loading={loadingCrop}
            >
              {<IntlMessages id="propertyPage.modal.save" />}
            </Button>,
          ]}
        >
          {loading ? (
            <Loader />
          ) : (
            <Form
              form={visibleCrop ? cropForm : varietyForm}
              layout="vertical"
              scrollToFirstError
              fields={fields}
            >
              <div className="form-body">
                <Form.Item
                 name={visibleCrop ? ["crop", "name"] : ["variety", "name"]} 
                  className="isoInputWrapper"
                  label={visibleCrop ? "Crop" : 'Variety'}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input size="large" placeholder="Input crop" />
                </Form.Item>
              </div>
            </Form>
          )}
        </CropModalWrapper>
      </HarvestModalWrapper>

      <AddActivityModal
        visibleActivity = {props.visibleActivity}
        selectedData = {dataObject?.id}
        cancelModalActivity = {props?.cancelModalActivity}
        propertyId={props.propertyId}
      />
    </>
  );
};

export default HarvestModal;

const ColorItemRow = styled.div`
  display: flex;
  align-items: center;
  line-height: 30px;
  div {
    margin: 4px;
  }
`;

const ColorItemPreview = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 2px;
`;
const AcreageInput = styled.div`
  display: flex;
  align-items: flex-start;
`;
const SuffixAddon = styled.span`
  margin-top: 30px;
  margin-bottom: 5px;
  line-height: 38px;
  color: #747784 !important;
  flex-shrink: 0;
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
  border-right-width: 1px !important;
  min-width: 50px;
  background-color: #f8f9fa;
  border: solid #d9d9d9;
  border-width: 1px 0;
  white-space: nowrap;
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
`;
const TemperatureInput = styled.div`
  display: flex;
  align-items: flex-start;
`;